<template>
  <DetailsLayout
    type="block"
    currency="Bitcoin"
    :date="header?.date"
    :copyValue="header?.copyValue"
    :rate="rate"
    :isLoading="isLoading"
    :error="error"
  >
    <template #left>
      <MainInfo
        :icon="network"
        :title="network === 'bitcoin' ? 'Bitcoin block' : 'TRON block'"
        :subtitle="mainInfo?.subtitle"
        :copyValue="mainInfo?.copyValue"
      />
    </template>
    <template #right>
      <Block :prev="887456" :current="887457" :next="887458" />
      <BlockInfo
        hash="0000000000000000000274d1d18c61604b69acf4f26a7fa7de0c1825d2c20e6a"
        :data="
          network === 'bitcoin'
            ? blockTable
            : [
                {
                  id: 1,
                  label: 'Mined on',
                  value: {
                    title: '12 Mar 2025 10:56:49 UTC',
                    subtitle: '(20 minutes ago)',
                  },
                },
              ]
        "
      />
      <TransactionsTable :data="transactionsTableData" />
    </template>
  </DetailsLayout>
</template>

<script>
import { mapActions } from "vuex";
import { DetailsLayout } from "@/widgets";
import { MainInfo, Block, BlockInfo, TransactionsTable } from "@/features";
import { transactionFormatter } from "@/shared/utils/formaters";
import { bitcoinTransaction } from "../app/mocks";
import { transactionsData } from "@/app/mocks/transactionsData";
import { inputs, outputs } from "@/app/mocks/transactionsMain";

export default {
  name: "BlockPage",
  components: { DetailsLayout, MainInfo, Block, BlockInfo, TransactionsTable },
  data() {
    return {
      isLoading: false,
      error: "",
      data: null,
      transactionsData,
      inputs,
      outputs,
    };
  },
  methods: {
    ...mapActions("explorer", ["GET_ADDRESS", "SEARCH"]),
    ...mapActions("alerts", ["ADD_ALERT"]),
  },

  async mounted() {
    this.isLoading = true;
    try {
      const response = bitcoinTransaction;
      this.data = transactionFormatter(response);
    } catch (error) {
      this.error = error;
    } finally {
      this.isLoading = false;
    }
  },
  computed: {
    header() {
      return this.data?.header;
    },
    rate() {
      return this.data?.rate;
    },
    mainInfo() {
      return this.data?.mainInfo;
    },
    network() {
      return this.$route.params.network;
    },
  },
};
</script>
